import Form from 'react-bootstrap/Form';
import './AssistanceForm.scss'
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import ImageViewer from '../ImageViewer/ImageViewer.component';
import { ISelectOptions } from 'aw-combobox';
import { Assistance } from '../../../utils/models/Assistance';
import { Modal } from 'react-bootstrap';
import { AWSelect } from 'aw-select';
import { useTheme } from '../../../utils/contexts/ThemeContext';

const AssistanceForm = (props: {
    showModal: boolean;
    formLock: boolean;
    edit: boolean;
    assistanceAux: Assistance;
    machineOptions: ISelectOptions[];
    usersOptions: ISelectOptions[];
    typesOptions: ISelectOptions[];
    stateOptions: ISelectOptions[];
    onHide: (e: any) => void
    onSave: (a: Assistance) => void;
}) => {

    const { t } = useTranslation();
    const { assistanceAux, usersOptions, typesOptions, machineOptions, stateOptions } = props
    const [assistanceForm, setAssistanceForm] = useState(assistanceAux)

    const [selectedUser, setSelectedUser] = useState<ISelectOptions | null>(null)
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions | null>(null)
    const [selectedType, setSelectedType] = useState<ISelectOptions | null>(null)
    const [selectedState, setSelectedState] = useState<ISelectOptions | null>(null)

    useEffect(() => {
        if (assistanceAux) {
            setAssistanceForm(assistanceAux);
            setSelectedUser(usersOptions.find((u) => u.value === assistanceAux.userId) ?? null);
            setSelectedMachine(machineOptions.find((m) => m.value === assistanceAux.machineId) ?? null);
            setSelectedType(typesOptions.find((t) => t.value === assistanceAux.type) ?? null);
            setSelectedState(stateOptions.find((s) => s.value === assistanceAux.stateId) ?? null);
        }
    }, [assistanceAux, usersOptions, machineOptions, typesOptions]);

    const handleSave = () => {
        let saveAssistance: Assistance = {
            ...assistanceForm,
            userId: Number(selectedUser?.value) ?? null,
            machineId: Number(selectedMachine?.value) ?? null,
            type: Number(selectedType?.value) ?? 0,
            stateId: Number(selectedState?.value) ?? 0,
            assistance_date: new Date(assistanceForm.assistance_date) ?? new Date()
        }
        props.onSave(saveAssistance);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setAssistanceForm((prev) => ({ ...prev, [name]: value }));
    };

    const theme = useTheme();

    const dark = theme.theme==='dark';

    return (
        <Modal dialogClassName="aw-modal-alarm" show={props.showModal} keyboard={false} backdrop={'static'} size="lg">
            <Modal.Header className="position-relative d-block">
                <p className="modal-title-custom m-0 text-start text-lg-center">{!props.edit ? t('EditIncidence') : t('NewIncidence')}</p>
                <button type='button' className='btn-close custom-close position-absolute end-0 top-50 translate-middle-y me-3' aria-label='Close' onClick={props.onHide} style={{ color: 'var(--text-primary)' }}> </button>
            </Modal.Header>
            <Modal.Body>
                <div className="rounded-1" id='formAssistanceContainer'>
                    <Form id="assistenceForm">
                        <div className="row mb-3" style={{ color: "var(--text-primary)" }}>
                            <div className="col">
                                <Form.Label className='mb-0'>{`${t('Identifier')}`}</Form.Label>
                                <Form.Control disabled={true} name="id" type="text" value={assistanceForm.id} />
                            </div>
                            <div className="col-6">
                                <Form.Label className='mb-0'>{`${t('Title')}*`}</Form.Label>
                                <Form.Control disabled={props.formLock} name="title" type="text" onChange={handleChange} value={assistanceForm.title} />
                            </div>
                            <div className="col">
                                <Form.Label className='mb-0'>{`${t('Date')}*`}</Form.Label>
                                <Form.Control disabled={props.formLock} name="assistance_date" type="datetime-local" onChange={handleChange} value={format(new Date(assistanceForm.assistance_date), "yyyy-MM-dd HH:mm").replace('T', ' ')} />
                            </div>

                            {/* <div className="col">
                                <Form.Label className='mb-0'>{t('Installation')}</Form.Label>
                                <Form.Control disabled={props.formLock} name="canteen_name" type="text" onChange={handleChange} value={assistanceForm.canteen_name} />
                            </div> */}
                        </div>
                        <div className="row mb-3">
                            <div className="col-12 col-lg">
                                <Form.Label className='mb-0'>{t('Machine')}</Form.Label>
                                <AWSelect dark={dark} name='machine' disabled={props.formLock} closeMenuOnSelect={true} value={selectedMachine} onChange={setSelectedMachine} options={props.machineOptions}  />
                            </div>
                            <div className="col col-lg-3">
                                <Form.Label className='mb-0'>{t('Type')}</Form.Label>
                                <AWSelect dark={dark} name='type' disabled={props.formLock} closeMenuOnSelect={true} value={selectedType} onChange={setSelectedType} options={props.typesOptions}  />
                            </div>
                            <div className="col col-lg-3">
                                <Form.Label className='mb-0'>{t('State')}</Form.Label>
                                <AWSelect dark={dark} name='type' disabled={props.formLock} closeMenuOnSelect={true} value={selectedState} onChange={setSelectedState} options={props.stateOptions}  />
                            </div>
                            <div className="col-12 col-lg">
                                <Form.Label className='mb-0'>{t('User')}</Form.Label>
                                <AWSelect dark={dark} name='user' disabled={props.formLock} closeMenuOnSelect={true} value={selectedUser} onChange={setSelectedUser} options={props.usersOptions}  />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <Form.Label className='mb-0'>{t('Description')}</Form.Label>
                                <Form.Control disabled={props.formLock} maxLength={1000} name="description" as="textarea" onChange={handleChange} value={assistanceForm.description} rows={6} style={{ resize: 'none' }} />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-12 col-lg-4'>
                                <Form.Label className='mb-0'>{`${t('Images')} (jpg, png - 200Kb)`}</Form.Label>
                                <Form.Control name="logo" accept="image/*" type="file" onChange={handleChange} />
                            </div>
                            <div className='col imagesViewerContiner'>
                                <ImageViewer formLock={props.formLock} onDeleteImage={() => null} imageFolder={assistanceAux.imagesFolder} />
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button form="assistenceForm" className="btn-Custom btn-IDGreen" type="button" onClick={handleSave}><i className="bi bi-save"></i></button>
            </Modal.Footer>
        </Modal>
    )
}
export default AssistanceForm;